import { render, staticRenderFns } from "./edit-bnu.vue?vue&type=template&id=490b3e8e"
import script from "./edit-bnu.vue?vue&type=script&lang=js"
export * from "./edit-bnu.vue?vue&type=script&lang=js"
import style0 from "./edit-bnu.vue?vue&type=style&index=0&id=490b3e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports